import React, { useState } from "react";
import {
  GetApplicationListQueryVariables,
  GetNotificationListQueryVariables,
  useGetApplicationListQuery,
  useGetNotificationListQuery,
} from "views/utils/graphql/graphql";

export const useGetNotificationList = (
  initValues: GetNotificationListQueryVariables
) => {
  const [noticeListVariables, setNoticeListVariables] =
    useState<GetNotificationListQueryVariables>(initValues);
  const [noticeList, getNoticeList] = useGetNotificationListQuery({
    variables: noticeListVariables,
    requestPolicy: "network-only",
  });

  return {
    noticeList,
    getNoticeList,
    setNoticeListVariables,
  };
};
